"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideIframe = exports.showIframe = exports.mountIframe = void 0;
const tslib_1 = require("tslib");
const get_iframe_1 = require("./get-iframe");
const make_iframe_1 = require("./make-iframe");
const mountIframe = ({ iframe, onLoad }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    console.debug('mountIframe', { iframe });
    window.document.body.appendChild(iframe);
    iframe.onload = onLoad;
});
exports.mountIframe = mountIframe;
const showIframe = () => {
    const iframe = (0, get_iframe_1.getIframe)();
    if (!iframe)
        return;
    console.debug('showIframe', { iframe });
    Object.assign(iframe.style, Object.assign(Object.assign({}, make_iframe_1.baseStyle), { display: 'block' }));
};
exports.showIframe = showIframe;
const hideIframe = () => {
    const iframe = (0, get_iframe_1.getIframe)();
    if (!iframe)
        return;
    console.debug('hideIframe', { iframe });
    Object.assign(iframe.style, Object.assign(Object.assign({}, make_iframe_1.baseStyle), { display: 'none' }));
};
exports.hideIframe = hideIframe;
